import { SvgIcon, SvgIconProps } from "@mui/material";
import { ReactComponent as AICloseIconSvg } from "../../assets/svg/ai-close.svg";

const AICloseIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <AICloseIconSvg fill="currentColor" />
    </SvgIcon>
  );
};

export { AICloseIcon };
